import { SxProps, Theme } from "@mui/material";
import { isNil } from "lodash-es";

import { GeneralCurrencyDto, GeneralCurrencyInputDto } from "@/core/api/generated/v1";

import CurrencyCodeDisplay from "../../../Form/Display/CurrencyCodeDisplay";

interface Props {
  currency?: GeneralCurrencyDto | GeneralCurrencyInputDto;
  sx?: SxProps<Theme>;
}

export default function GeneralCurrencyDisplay({ sx, currency }: Props) {
  if (isNil(currency)) {
    return null;
  }
  return <CurrencyCodeDisplay currencyCode={currency?.code} sx={sx} />;
}
